import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle';
import ProjectCard from '../Cards/ProjectCards';
import { projects } from '../../data/constants';

const CATEGORIES = [
  { value: 'all', label: 'All' },
  { value: 'web app', label: 'WEB APP\'S' },
  { value: 'AI/ML', label: 'AI/ML' },
  { value: 'Backend', label: 'Backend' },
  { value: 'Python', label: 'Python' },
  { value: 'Other', label: 'Other' }
];

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');

  const filteredProjects = useMemo(() => {
    return toggle === 'all'
      ? projects
      : projects.filter(item => item.category === toggle);
  }, [toggle]);

  return (
    <Container id="projects">
    <Wrapper>
      <Title data-aos="fade-left" data-aos-duration="2000">Projects</Title>
      <Desc data-aos="fade-down" data-aos-duration="2000">
      Explore my other web and Python projects
      </Desc>
      <ToggleButtonGroup data-aos="fade-up-right" data-aos-duration="2000" >
        {toggle === 'all' ?
          <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          :
          <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
        }
        <Divider />
        {toggle === 'web app' ?
          <ToggleButton active value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
          :
          <ToggleButton value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
        }
        <Divider />
        {toggle === 'Backend' ?
          <ToggleButton active value="Backend" onClick={() => setToggle('Backend')}>Backend</ToggleButton>
          :
          <ToggleButton value="Backend" onClick={() => setToggle('Backend')}>Backend</ToggleButton>
        } <Divider />
        {toggle === 'AI/ML' ?
          <ToggleButton active value="AI/ML" onClick={() => setToggle('AI/ML')}>AI/ML</ToggleButton>
          :
          <ToggleButton value="AI/ML" onClick={() => setToggle('AI/ML')}>AI/ML</ToggleButton>
        }

        <Divider />
        {toggle === 'Python' ?
          <ToggleButton active value="Python" onClick={() => setToggle('Python')}>Python</ToggleButton>
          :
          <ToggleButton value="Python" onClick={() => setToggle('Python')}>Python</ToggleButton>
        }
      </ToggleButtonGroup>
      <CardContainer data-aos="fade-zoom-in"
>
        {toggle === 'all' && projects
          .map((project) => (
            <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
          ))}
        {projects
          .filter((item) => item.category == toggle)
          .map((project) => (
            <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
          ))}
      </CardContainer>
    </Wrapper>
  </Container>
  );
};

Projects.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired
};

export default React.memo(Projects);
